import React from 'react';
import { Section } from './ui/Section';
import { AlertCircle } from 'lucide-react';
export function Urgency() {
  return <Section className="bg-brand-accent text-brand-dark py-24" data-id="element-350">
      <div className="max-w-4xl mx-auto text-center" data-id="element-351">
        <AlertCircle className="w-16 h-16 mx-auto mb-8 opacity-80" data-id="element-352" />
        <h2 className="text-4xl md:text-5xl font-bold mb-8 text-brand-dark" data-id="element-353">
          ¿Por Qué Actuar Ahora?
        </h2>

        <div className="space-y-6 text-xl md:text-2xl font-medium leading-relaxed mb-12" data-id="element-354">
          <p data-id="element-355">
            Cada día que pasa sin una presencia digital profesional es un día en
            que alguien más está tomando los clientes que podrían ser tuyos.
          </p>
          <p className="font-bold text-2xl md:text-3xl" data-id="element-356">
            Tu competencia no está esperando.
          </p>
          <p data-id="element-357">
            Los clientes que podrían contratarte hoy están buscando en este
            momento a alguien que haga lo que tú haces. Y si no te encuentran —
            o si te encuentran pero no los convences en los primeros segundos —
            simplemente eligen a otro.
          </p>
        </div>

        <div className="inline-block bg-brand-dark text-white px-8 py-4 rounded-full font-bold text-xl shadow-xl" data-id="element-358">
          ¿Cuánto tiempo más puedes permitirte eso?
        </div>
      </div>
    </Section>;
}